@import '../../../globals/main.scss';

pn-multi-row-connected-dropdown {
  gap: 1rem;

  .connected-dropdown {
    &__row {
      display: flex;
      align-items: flex-start;
      gap: 1rem;
      margin-bottom: 1rem;
      justify-content: space-between;

      &__no-margin {
        margin: 0;
      }
    }

    &__button-right {
      margin-left: auto;
    }
  }
}
